import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { tableClass: "events-users-table" }
const _hoisted_2 = { class: "events-users-table__body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableWithOuterFilter = _resolveComponent("TableWithOuterFilter")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("h2", { class: "events-users-table__title" }, "Действия пользователей", -1)),
      _createVNode(_component_TableWithOuterFilter, {
        tableClass: "events-users-table__table",
        tableConfig: _ctx.tableConfig,
        filtersConfig: _ctx.getFiltersConfig,
        defaultFilter: _ctx.filter,
        onSearchFilter: _ctx.searchFilter,
        isLifeSync: ""
      }, null, 8, ["tableConfig", "filtersConfig", "defaultFilter", "onSearchFilter"])
    ])
  ]))
}